function Aa(text) {
  return text?.slice(0, 1).toUpperCase() + text?.slice(1);
}

export { Aa };
